import * as types from "./types";
import * as EstateState from "./state";

const clearState = (oldState, newState) => {
  if (oldState !== null && oldState !== undefined) {
    Object.keys(oldState).forEach((key) => {
      if (typeof oldState[key] === "object") {
        if (oldState[key] instanceof Array) {
          if (key !== "validation") {
            oldState[key] = [];
          } else {
            oldState[key].forEach((step) => {
              step.status = false;
            });
          }
        } else {
          oldState[key] = clearState(oldState[key], newState[key]);
        }
      } else {
        // oldState[key] = newState[key]
        if (key === "cur") {
          oldState[key] = "EUR";
        } else {
          oldState[key] = null;
        }
      }
    });
  }
  return oldState;
};

export const mutations = {
  [types.CLEAR](state) {
    state = clearState(state, EstateState.default);
  },
  [types.SET_ID](state, { data }) {
    state.idUser = data.id;
  },
  [types.UPDATED_AT](state, { data }) {
    state.updatedAt = data.updatedAt;
    state.completedAt = data.completedAt;
  },
  [types.VALIDATION](state, data) {
    state.validation.forEach((validate) => {
      if (validate.name === data) {
        validate.status = true;
      }
    });
  },
  [types.YOUR_INFORMATIONS](state, { data }) {
    console.log("MUTATION YOUR_INFORMATIONS - data received:", data);
    console.log("MUTATION YOUR_INFORMATIONS - birthdate value:", data.birthdate);
    state.birthdate = data.birthdate;
    state.job = data.job;
    state.csp = data.csp;
    state.maritalStatus = data.maritalStatus;
    console.log("MUTATION YOUR_INFORMATIONS - state.birthdate after mutation:", state.birthdate);
  },
  [types.YOUR_HOME](state, { data }) {
    state.childs = data;
  },
  [types.ANNUAL_RECIPE](state, { data }) {
    state.directIncome = data.directIncome;
    state.secondIncome = data.secondIncome;
  },
  [types.REAL_ESTATE](state, { data }) {
    state.mainEstate = data.mainEstate;
    state.secondaryEstates = data.secondaryEstates;
    state.rentalProperties = data.rentalProperties;
    state.isSCPI = data.isSCPI;
    state.scpi = data.scpi;
  },
  [types.SAVINGS](state, { data }) {
    state.savings = data;
  },
  [types.GFR](state, { data }) {
    state.gfr = data;
  },
  [types.SPENDING_NO_TAXES](state, { data }) {
    state.spendingNoTaxes = data.spending;
    state.periodicity = data.periodicity;
  },
  [types.CREDITS](state, { data }) {
    state.credits = data.loans;
    state.overallDebtPercentage = data.overallDebtPercentage;
  },
  [types.TAXES](state, { data }) {
    state.taxes = data;
  },
  [types.ISF](state, { data }) {
    state.isf = data;
  },
  [types.RETREAT](state, { data }) {
    state.retreat = data;
  },
  [types.INFLUENCE](state, { data }) {
    state.influence = data;
  },
  [types.FOLLOWING](state, { data }) {
    state.follow = data;
  },
  [types.KNOWLEDGE](state, { data }) {
    state.knowledge = data;
  },
  [types.PERSPECTIVE](state, { data }) {
    state.perspective = data;
  },
  [types.ESG](state, { data }) {
    state.esg = data;
  },
  [types.TOTAL](state, { data }) {
    state.total = data;
  },
  [types.ADVISOR_CHECK](state, { data }) {
    console.log("updating advisor check", data);
    state.advisorCheck = data;
  },
};



// WEBPACK FOOTER //
// ./src/common/store/PatrimonialEstate/mutations.js